export default __webpack_public_path__ + "static/media/videoCourse.b1afb616.svg";